<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Associated Companies</h3>
    @if (isAdmin || isSystemUser) {
    <div class="card-actions">
      @if (!isEditingAssociations) {
      <button mat-flat-button color="primary" type="button" (click)="toggleEditAssociations()">
        Edit
      </button>
      }
    </div>
    }
  </div>

  <div class="pro-card column">
    @if (!isEditingAssociations) {
    <div class="associations-container">
      @if (associatedOrganizations.length > 0) {
      <div class="associations-list">
        @for (assoc of associatedOrganizations; track assoc.id) {
        <div class="org-box association-box">
          {{ assoc.name }}
        </div>
        }
      </div>
      }
      @if (associatedOrganizations.length === 0) {
      <div class="empty-state">
        <p class="text-muted">No associated companies</p>
      </div>
      }
    </div>
    }
    @if (isEditingAssociations) {
    <form [formGroup]="associationForm">
      <div class="custom-form-field">
        <label>Select Associated Companies:</label>
        <app-mat-multi-select-pagination
          [requiredMessage]="'Please select associated companies'"
          [options]="allProviderOrganizations"
          [control]="associationForm.controls['associatedOrgIds']"
          [innerLabel]="'Select companies'"
          [hasNextPage]="hasNextPageOrganizations"
          (loadMore)="onLoadMoreOrganizations($event)"
        />
      </div>

      <div class="form-actions" style="display: flex; gap: 12px; margin-top: 16px;">
        <button mat-stroked-button type="button" (click)="cancelEditAssociations()">
          Cancel
        </button>
        <button mat-flat-button color="primary" type="button" (click)="saveAssociationChanges()"
          [disabled]="isLoading">
          Save Changes
        </button>
      </div>
    </form>
    }
  </div>
</div>